document.querySelectorAll('.card-info-wrap .card-info .card-heading.typography-body a.js-product-link')
.forEach(el => {
    const maxChars = 48;
    const text = el.textContent.trim();

    if (text.length > maxChars) {
        el.textContent = text.slice(0, maxChars) + '...';
    }
});